import React, { useState } from 'react'
import Input from 'react-phone-number-input/input'
import { ArrowLeftIcon, ArrowRightIcon, PhoneIcon, XCircleIcon } from '@heroicons/react/outline'

export default function Step9({ nextStep, prevStep, updateFieldValue, value }) {

    const [phone, setPhone] = useState(value);
    const [error, showError] = useState(false)

    const handleNextStep = () => {
        if (!phone || phone.replace("+", '').length !== 11) {
            showError(true)
        } else {
            updateFieldValue("cellPhone", phone);
            nextStep(11)
        }
    }


    return (
        <div id="step11" >
            <div className='max-w-lg mx-auto p-10'>
                <fieldset>
                    <legend className='font-normal text-base px-4 md:px-6'>What is the best number to reach you?</legend>
                    <div className='relative mt-5 ml-2 text-base text-gray-800'>
                        <div className='absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 flex items-center'>
                            <PhoneIcon className="h-5 w-5 " />
                        </div>
                        <Input
                            country="US"
                            id="phone"
                            name="cellPhone"
                            value={phone}
                            onChange={setPhone}
                            className={`h-12 w-full rounded-md border font-semibold text-base pl-11 pr-4 ${error
                                ? "border-red-600 bg-red-50"
                                : "border-gray-400 bg-white"
                                }`}
                        />


                    </div>
                    {error && (
                        <p className="mt-2 flex text-xs text-red-500">
                            <XCircleIcon className="h-4 w-4 mr-1" />
                            Please enter a valid U.S. phone number.
                        </p>
                    )}
                </fieldset>
            </div>
            <div className="relative flex items-center justify-between w-full h-14 bg-blue-600 rounded-b-md">
                <button
                    id="calcStep11Prev"
                    onClick={() => prevStep(11)}
                    className="flex items-center h-full w-fit rounded-bl-md hover:bg-blue-800 text-white text-base px-5 py-1.5 font-semibold uppercase">
                    <ArrowLeftIcon className='h-5 w-5 mr-2' /> <span className="hidden md:block">Prev</span>
                </button>

                {/* Centered Step Counter */}
                <div className="absolute left-1/2 -translate-x-1/2 text-white opacity-50">
                    11 of 12
                </div>

                {/* Next Button */}
                <button
                    id="calcStep11Next"
                    onClick={() => handleNextStep()}
                    className="flex items-center h-full px-5 font-semibold text-white uppercase bg-blue-600 rounded-br-md hover:bg-blue-800"
                >
                    <span className="hidden md:block">Next</span>
                    <ArrowRightIcon className="w-5 h-5 ml-2" />
                </button>
            </div>

        </div>
    );
}